import styled from 'styled-components';
import Colours from '/shared/styled/Colours';

export default styled.div`
  color: ${Colours.white};

  > strong {
    font-weight: 700;
  }
`;
